// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.block-interpreter-modal .sk-input__input-wrapper--textarea {\n  height: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
